import { render, staticRenderFns } from "./ExercisesTab.vue?vue&type=template&id=7cb9f063&"
import script from "./ExercisesTab.vue?vue&type=script&lang=js&"
export * from "./ExercisesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports